import { InfoCircleOutlined } from "@ant-design/icons";
import { Card, Col, InputNumber, Radio, Row } from "antd";
import React from "react";


const BusModeSettings = (props) => {
    const {isUpdateAllowValue, onUpdateValue, settingsList} = props;

    return <Card className="pos-card">
    <Row className="card-content flex-wrap" gutter={[16,16]}>
      <Col xs={24} md={12} className="left_content flex-wrap">
        <div className="card-heading">
          Bus Mode Settings
        </div>
        <div className="content_item flex-wrap">
            <label className="info_label">Allow Bus Mode:</label>
            <Radio.Group value={settingsList?.pos_allow_bus_time} onChange={(e)=>isUpdateAllowValue(e, 'pos_allow_bus_time')}>
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
            </Radio.Group>
        </div>
        <div className="content_item flex-wrap">
            <label className="info_label">Time required for bussing:</label>
            <InputNumber disabled={!settingsList?.pos_allow_bus_time} value={settingsList.pos_bus_time_mins} onChange={(e)=>{onUpdateValue(e, 'pos_bus_time_mins')}}/>
        </div>
      </Col>
      <Col xs={24} md={11} className="right_content">
        <label className="info_text"><InfoCircleOutlined style={{marginRight: 5}} />Bus mode means that you're either clearing or setting tables at a restaurant, before guests sit down and as they leave.</label>
      </Col>
      </Row>
  </Card>
};
export default BusModeSettings;